// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__BasmL","bg":"modal_bg__OOPTV","wrapper":"modal_wrapper__xLc+W","close":"modal_close__rjQrd"};